import { Component, OnInit } from '@angular/core';
import { NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { RestService } from '../../services/rest.service';
import { GlobalElement } from "../../services/global.elements";

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

  menu = [];
  permission = null;
  parent_permission = null;
  current_user = null;

  public scrollbarConfig: PerfectScrollbarConfigInterface;

  constructor(private restService: RestService, private router: Router) { }

  ngOnInit() {
    this.user_permission_by_iduser();
    this.user_read_one();

    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        // Show progress spinner or progress bar
      }
      if (event instanceof NavigationEnd) {
        // Hide progress spinner or progress bar
        //let url = event.url;
        //if (url == "/" || url == "") url = "/dashboard";
        //this.set_current_id(url);
        this.permission = GlobalElement.permission;
        /* if (this.parent_permission === null) {
          this.set_first_parent_permission();
        } */
        this.set_first_parent_permission();
      }
      if (event instanceof NavigationError) {
        // Hide progress spinner or progress bar
        // Present error to user
      }
    });

    const body = document.querySelector('body');
    // add class 'hover-open' to sidebar navitem while hover in sidebar-icon-only menu
    document.querySelectorAll('.sidebar .nav-item').forEach(function (el) {
      el.addEventListener('mouseover', function () {
        if (body.classList.contains('sidebar-icon-only')) {
          el.classList.add('hover-open');
        }
      });
      el.addEventListener('mouseout', function () {
        if (body.classList.contains('sidebar-icon-only')) {
          el.classList.remove('hover-open');
        }
      });
    });
  }

  set_parent_permission(_id) {
    if (_id == this.parent_permission) {
      this.parent_permission = "";
    } else {
      this.parent_permission = _id;
    }
  }

  set_first_parent_permission() {
    this.permission = GlobalElement.permission;
    for (let index = 0; index < this.menu.length; index++) {
      const element = this.menu[index].level2;
      if (element) {
        for (let index2 = 0; index2 < element.length; index2++) {
          const element2 = element[index2];
          if (element2.idpermission == this.permission) {
            this.parent_permission = element2.parent;
            return;
          }
        }
      }
    }
  }

  user_permission_by_iduser() {
    this.restService.user_permission_by_iduser().subscribe(data => {
      if (data.success) {
        this.menu = data.records;
      } else {
        this.menu = [];
      }
    }, err => {
      this.menu = [];
    });
  }

  user_read_one() {
    this.restService.user_read_one({}).subscribe(data => {
      if (data.success) {
        this.current_user = data.record;
      } else {
        this.current_user = null;
      }
    }, err => {
      this.current_user = null;
    });
  }

  get_initial(_value: string): string {
    if (_value && _value.length > 0) return _value.substring(0, 1);
    else return "!";
  }

}
